import { castToString } from '../utils/cast-to-string';
import { isJSONValueObject } from '../utils/is-json-value-object';
export var InstructionType;
(function (InstructionType) {
    InstructionType["walk"] = "walk";
    InstructionType["turn"] = "turn";
    InstructionType["grab"] = "grab";
    InstructionType["drop"] = "drop";
    InstructionType["wait"] = "wait";
})(InstructionType || (InstructionType = {}));
;
export class Instruction {
    constructor(type, args) {
        this.type = type;
        this.args = args;
        this.type = type;
    }
    arg(argName, defaultValue) {
        if (Object.prototype.hasOwnProperty.call(this.args, argName)) {
            return this.args[argName];
        }
        return defaultValue;
    }
    static parse(command, args) {
        const commandString = castToString(command, null);
        if (!commandString || !InstructionType[commandString]) {
            throw new Error(`Unknown instruction: ${commandString}`);
        }
        const argsObject = isJSONValueObject(args) ? args : {};
        return new Instruction(commandString, argsObject);
    }
}
